export default __webpack_public_path__ + "static/media/Footer2_white_en.ad58d176.png";